import { createApolloClient } from 'vue-cli-plugin-apollo/graphql-client';
// eslint-disable-next-line import/no-extraneous-dependencies
import { setContext } from 'apollo-link-context';

export default function createGraphQLClient(jwt) {
  const httpEndpoint = process.env.VUE_APP_PARTNERS_API_BASE_URL + '/graphql';

  const link = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        Authorization: `Bearer ${jwt}`,
      },
    };
  });

  const clientOptions = {
    httpEndpoint,
    link,
  };

  return createApolloClient(clientOptions);
}
